const GUEST_ID_KEY = "trw_guest_id";

export function shouldEnablePostHog(
  isDev: boolean,
  projectToken?: string,
): boolean {
  return !isDev && Boolean(projectToken?.trim());
}

export function getOrCreateGuestId(): string {
  try {
    const existing = localStorage.getItem(GUEST_ID_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(GUEST_ID_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}